// src/App.tsx

import {
  DynamicContextProvider,
} from "@dynamic-labs/sdk-react-core";
import { SolanaWalletConnectors } from "@dynamic-labs/solana";
import BookLayout from './components/BookLayout';

export default function App() {
  return (
    <DynamicContextProvider
      settings={{
        environmentId: "72f5154f-c380-45ef-ab50-32f2eae705e0",
        walletConnectors: [SolanaWalletConnectors],
      }}
    >
      <BookLayout />
    </DynamicContextProvider>
  );
}
